import react from 'react'
import {Button, Typography, Input} from 'antd';
import './style.css';
import { Bbox } from './bbox';
import { updateTitle } from '../../client';
import { useParams } from 'react-router-dom';


interface IImageViewer {
    images: string[];
    headIndexes: number[];
    bboxes: {
        page: number,
        bbox: number[],
        errors: string[]
    }[];
    idealTitle: string;
    changeTitle: any;
    file: string;
}

export const ImageViewer: react.FC<IImageViewer> = (props) => {
    const [index, setIndex] = react.useState(0);
    const [headIndex, setHeadIndex] = react.useState(-1);
    const headIndexes = props.headIndexes;
    const bboxes = props.bboxes;
    const image = react.useRef(null);
    const imageHeight = 800;
    const [imageWidth, setImageWidth] = react.useState(0);
    const {id} = useParams();
    
    var bbox: any = [];
    bboxes.map((e) => {
        if (e.page == index) {
            bbox.push([e.bbox, e.errors])
        }
    })

    react.useEffect(() => {
        console.log((image.current as any).width);
        setImageWidth((image.current as any).width);
    });


    return <div className="centered">
        <div className='image__container'>
            {
                bbox.map((e: any) => {
                    return <Bbox
                        x={e[0][0] * imageWidth}
                        y={800 - e[0][1] * 800 - e[0][3] * imageHeight}
                        width={e[0][2] * imageWidth}
                        height={e[0][3] * imageHeight}
                        type='Грамматическая'
                        errors={e[1]}
                    ></Bbox>
                })
            }
            <img src={props.images[index]} alt="" height={800} ref={image} />
            <div className='controll__container'>
                <Button shape={'circle'} onClick={() => {
                    setIndex(Math.max(index-1, 0));
                }}>{"<"}</Button>
                <Button shape={'round'} onClick={() => {
                    var index = (headIndex + 1) % headIndexes.length
                    setHeadIndex(index);
                    setIndex(headIndexes[index]);
                }}>Следующий заголовок</Button>
                <Button shape={'circle'} onClick={() => {
                    setIndex(Math.min(props.images.length-1, index+1));                
                }}>{">"}</Button>
            </div>
            <div className="pagination">
                <Typography.Text style={{'textAlign': 'center'}}>
                    {index+1} / {props.images.length}
                </Typography.Text>
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 10
            }}>
                <Typography.Text>Эталонное название</Typography.Text>
                <Input value={props.idealTitle} onChange={(e) => {
                    props.changeTitle(e.target.value);
                }}></Input>
                <Button onClick={() => {
                    updateTitle(id as string, props.idealTitle);
                    //window.location.reload();
                }}>Изменить эталонное название</Button>
                <Typography.Link href={props.file}>Скачать размеченный файл</Typography.Link>
            </div>
        </div>
    </div>
}